export default "__VITE_ASSET__BbcVSF_s__"